module.exports = __webpack_public_path__ + "img/comp.04733a10.jpg";